import React, {Component} from "react"

import {H2, Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import authentication from "@irati/auth"
import OnboardingService, {OnboardingStep} from "@irati/onboarding/services/onboarding"
import {adminDashboardTracking} from "@irati-tracking/admin"
import Selector from "@irati/ui/src/Selector"

import {SelectorWrapper} from "./styled"

interface PillsInterface {
  key: string,
  reason: string
}

const PILLS: PillsInterface[] = [
  {
    key: "admin.dashboard.integrations.pill.noHrSystem",
    reason: "admin_dashboard_integrationsModule_clickDontShowAgain_clickDontHaveHrSystem"
  },
  {
    key: "admin.dashboard.integrations.pill.alreadyIntegrated",
    reason: "admin_dashboard_integrationsModule_clickDontShowAgain_clickAlreadyIntegrated"
  },
  {
    key: "admin.dashboard.integrations.pill.complicated",
    reason: "admin_dashboard_integrationsModule_clickDontShowAgain_clickTooComplicated"
  },
  {
    key: "admin.dashboard.integrations.pill.dontKnow",
    reason: "admin_dashboard_integrationsModule_clickDontShowAgain_clickUnsureOfValue"
  },
  {
    key: "admin.dashboard.integrations.pill.cantFind",
    reason: "admin_dashboard_integrationsModule_clickDontShowAgain_clickHrSystemNotOnList"
  },
  {
    key: "admin.dashboard.integrations.pill.notInterested",
    reason: "admin_dashboard_integrationsModule_clickDontShowAgain_clickNotInterested"
  },
  {
    key: "admin.dashboard.integrations.pill.other",
    reason: "admin_dashboard_integrationsModule_clickDontShowAgain_clickOther"
  }
]

interface Props extends InjectIntl{
  onHideIntegrations: () => void,
  onHideFeedback: () => void
}

interface State {
  showFeedbackSuccess: boolean,
  selectedReasons: string[]
}

class Feedback extends Component<Props, State> {
  state: State = {
    showFeedbackSuccess: false,
    selectedReasons: []
  }

  handleSubmit = () => {
    const {selectedReasons} = this.state
    OnboardingService.completeStep(authentication.user(), OnboardingStep.HAS_HIDDEN_INTEGRATIONS_MODULE).then(() => {
      adminDashboardTracking.submitReasons(selectedReasons)
      this.setState({showFeedbackSuccess: true})
    })
  }

  handlePillClick = (_, selectedReason: string) => {
    const reasonEvent = PILLS.find((pill) => this.props.formatMessage({id: pill.key}) === selectedReason)?.reason
    if (reasonEvent) {
      const {selectedReasons} = this.state
      let updatedReasons
      if (selectedReasons.find((reason) => reason === reasonEvent)) {
        updatedReasons = selectedReasons.filter((reason) => reason !== reasonEvent)
      } else {
        updatedReasons = [...selectedReasons, reasonEvent]
      }
      this.setState({selectedReasons: updatedReasons})
    }
  }

  render() {
    const {onHideIntegrations, onHideFeedback, formatMessage} = this.props
    const {showFeedbackSuccess, selectedReasons} = this.state

    return showFeedbackSuccess
      ? <>
        <H2 marginBottom={1}>
          <FormattedMessage id="admin.dashboard.integrations.feedbackSuccess.title" />
        </H2>
        <Body marginBottom={4}>
          <FormattedMessage id="admin.dashboard.integrations.feedbackSuccess.text" />
        </Body>
        <Button primary onClick={onHideIntegrations}>
          <FormattedMessage id="admin.dashboard.integrations.feedbackSuccess.button" />
        </Button>
        </>
      : <>
        <H2 marginBottom={1}>
          <FormattedMessage id="admin.dashboard.integrations.feedback.title" />
        </H2>
        <Body marginBottom={4}>
          <FormattedMessage id="admin.dashboard.integrations.feedback.text" />
        </Body>
        <SelectorWrapper>
          {PILLS.map((pill: PillsInterface) => <Selector
            id="adminSection_integrationFeedbackOption"
            name={formatMessage({id: pill.key})}
            onClick={this.handlePillClick}
            selected={selectedReasons.includes(pill.reason)} />
          )}
        </SelectorWrapper>
        <Button id="adminSection_feedback_submit_button" marginTop={4} primary onClick={this.handleSubmit}>
          <FormattedMessage id="admin.dashboard.integrations.feedback.button.confirm" />
        </Button>
        <Button id="adminSection_feedback_cancel_button" marginLeft onClick={onHideFeedback}>
          <FormattedMessage id="admin.dashboard.integrations.feedback.button.cancel" />
        </Button>
      </>
  }
}

export default injectIntl(Feedback)
